import { render, staticRenderFns } from "./digikalaOrderList.vue?vue&type=template&id=0740d7d6&scoped=true&"
import script from "./digikalaOrderList.vue?vue&type=script&lang=js&"
export * from "./digikalaOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0740d7d6",
  null
  
)

export default component.exports